import React from 'react';
import { useTranslation } from 'react-i18next';

import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import ReactCountryFlag from 'react-country-flag';

const LanguageSelector = () => {
	const { i18n } = useTranslation();

	const [language, setLanguage] = React.useState(i18n.language || 'en');

	React.useEffect(() => {
		setLanguage(i18n.language || 'en');
	}, [i18n.language]);

	const handleChange = (event) => {
		const selectedLanguage = event.target.value;
		setLanguage(selectedLanguage);
		i18n.changeLanguage(selectedLanguage);
		// Force a re-render by updating the language state
		setTimeout(() => {
			setLanguage(i18n.language);
		}, 100);
	};
	return (
		<>
			{/* <div style={{ position: "absolute", right: "2em" }}></div> */}
			<FormControl>
				<Select
					variant="standard"
					labelId="demo-simple-select-label"
					id="demo-simple-select"
					value={language}
					onChange={handleChange}
					style={{ width: '4.5em', border: 'none' }}>
					{/* HUNGARIAN */}
					<MenuItem value={'hu'}>
						<ReactCountryFlag
							countryCode="HU"
							svg
							style={{
								height: '1rem',
								borderRadius: '4px',
							}}
							title="HU"
						/>{' '}
						<span
							style={{ fontFamily: 'Satoshi, sans-serif', fontWeight: '600' }}>
							Hu
						</span>
					</MenuItem>
					{/* ENGLISH */}
					<MenuItem value={'en'}>
						<ReactCountryFlag
							countryCode="US"
							svg
							style={{
								height: '1em',
								borderRadius: '4px',
							}}
							title="US"
						/>{' '}
						<span
							style={{ fontFamily: 'Satoshi, sans-serif', fontWeight: '600' }}>
							En
						</span>
					</MenuItem>
					{/* EMPTY */}
					<MenuItem value={'empty'}>
						<span
							style={{ fontFamily: 'Satoshi, sans-serif', fontWeight: '600' }}>
							Empty
						</span>
					</MenuItem>
					{/* ROMANIAN
          <MenuItem value={'ro'}>
            <ReactCountryFlag
              countryCode='RO'
              svg
              style={{
                height: '1em',
                borderRadius: '4px',
              }}
              title='RO'
            />{' '}
            <span style={{ fontFamily: 'Satoshi', fontWeight: '600' }}>
              Ro
            </span>
          </MenuItem> */}
				</Select>
			</FormControl>
		</>
	);
};

export default LanguageSelector;
